import { __rest } from '../node_modules/tslib/tslib.es6.mjs.js';
import React__default from 'react';
import classNames from 'classnames';

const Badge = (props) => {
    const { className, children, options, variant = 'primary', backgroundColor, fontColor, borderColor } = props, restOfProps = __rest(props, ["className", "children", "options", "variant", "backgroundColor", "fontColor", "borderColor"]);
    // Add classes here for variation of pills
    const classNames$1 = classNames('xps-badge', variant, className);
    return (React__default.createElement("div", Object.assign({ className: classNames$1 }, restOfProps, { style: { backgroundColor: backgroundColor, color: fontColor, borderColor: borderColor } }), children));
};

export { Badge, Badge as default };
//# sourceMappingURL=Badge.js.map
